import {Component, EventEmitter, Input, Output} from '@angular/core';

// Toast card fixed in the top-right corner: Hexagon logo, title, close button; the body (text, buttons) is projected.
// Used by the "New version available" toast (version-banner).
@Component({
    selector: 'app-toast-card',
    templateUrl: './toast-card.component.html',
    styleUrls: ['./toast-card.component.scss'],
})
export class ToastCardComponent {
    // Not 'title': a static title attribute would also stay on the element and show as a browser tooltip
    @Input() heading: string;
    // Distance from the top of the window (default: below the app's navbar)
    @Input() top = '70px';
    @Output() closed = new EventEmitter<void>();
}
